export default __webpack_public_path__ + "d9467ee321a8f38aefffb511625622b3.woff2";